export const LayoutHeader = (props) => <header>{props.children}</header>
export const LayoutMain = (props) => <main>{props.children}</main>
export const LayoutFooter = (props) => <footer>{props.children}</footer>

export const LayoutRoot = (props) => <div>{props.children}</div>
